// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","secondary":"Button_secondary__QwN49"};